// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".specsheet-img img{height:300px;width:300px}", "",{"version":3,"sources":["webpack://./resources/js/components/product/SpecSheetPartOne.vue"],"names":[],"mappings":"AACA,mBACiB,YAAA,CAAb,WACJ","sourcesContent":["\n.specsheet-img img{\n    width:300px; height:300px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
